import {
  generateBooking,
  generateFee,
  generateVisit
} from 'mocks/data/bentobox/booking';

export const getFullName = (firstName?: string, lastName?: string): string =>
  `${firstName ? `${firstName} ` : ''}${lastName ?? ''}`;

export const getNumberOfGuests = (partySize: number): string =>
  `Party of ${partySize}`;

export const getStyledTopMatterContainerMaxWidth = (
  pathname?: string,
  hasBrandEngineFeature: boolean = false
): string => {
  let maxWidth = '632';

  if (hasBrandEngineFeature) {
    if (pathname?.includes('/modify')) {
      maxWidth = '568';
    } else if (pathname?.includes('/booking')) {
      maxWidth = '1024';
    } else {
      maxWidth = '600';
    }
  }

  return maxWidth + 'px';
};

export const generateDummyBooking = (
  hasFeePolicy: boolean,
  hasChecklessEnabled: boolean
) =>
  generateBooking({
    visit: generateVisit({
      opt_in_checkless: hasChecklessEnabled
    }),
    fee: generateFee({
      shouldCollect: hasFeePolicy
    })
  });
